import { useRef } from "react";
import { Input } from "@/components/ui/input";

// 286: číselné pole bez „0“ na začátku. Nula se při kliknutí smaže (dřív psaní
// „40000“ dalo „040000“), jiná hodnota se označí a přepíše. onChange dostává text pole.
// 401: nula smazaná jen kliknutím se při odchodu z pole vrátí — jinak se uložilo prázdné pole
// (u K úhradě po zálohách = celá faktura k úhradě)
export function NumInput({ value, onChange, onBlur, raw = false, ...p }) {
  const zero = useRef(null);
  const focus = (e) => {
    zero.current = null;
    if (value !== "" && value != null && Number(String(value).replace(",", ".")) === 0) { zero.current = value; onChange(""); return; }
    const el = e.target, v0 = el.value;
    const sel = () => { try { el.select(); } catch { /* pole bez výběru */ } };
    sel();
    // Safari výběr po kliknutí zruší — znovu, jen dokud člověk nezačal psát.
    setTimeout(() => { if (document.activeElement === el && el.value === v0) sel(); }, 0);
  };
  const C = raw ? "input" : Input;
  const blur = (e) => {
    if (zero.current != null && e.target.value === "") onChange(String(zero.current));
    zero.current = null;
    onBlur?.(e);
  };
  return <C type="number" inputMode="decimal" placeholder="0" value={value ?? ""}
    onChange={(e) => { zero.current = null; onChange(e.target.value); }} onFocus={focus} onBlur={blur} {...p} />;
}
